import { render } from "./IntraPersonal.vue?vue&type=template&id=6c4bddfc"
import script from "./IntraPersonal.vue?vue&type=script&lang=js"
export * from "./IntraPersonal.vue?vue&type=script&lang=js"

import "./IntraPersonal.vue?vue&type=style&index=0&id=6c4bddfc&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__